<template>
    <WebViewScreen
        class="mailbox-container"
        no-pad
        title="Notices"
        disable-when-offline
    >
        <template #left-button>
            <div v-if="embedded" class="drawer-icon" @click="onOpenDrawer">
                <svg
                    width="23"
                    height="21"
                    viewBox="0 0 23 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.26264 5.42834C6.80293 5.42376 7.33008 5.58615 7.76416 5.89089C8.19824 6.19563 8.51558 6.62611 8.66808 7.11707C8.75145 7.40807 8.77269 7.7119 8.73058 8.01077C8.68847 8.30964 8.58385 8.59756 8.42283 8.85767C8.26181 9.11778 8.04764 9.34486 7.79285 9.52562C7.53805 9.70638 7.24775 9.83719 6.93893 9.9104C6.68916 9.96863 6.38752 10.0196 5.66127 10.2034C5.61733 10.2149 5.57626 10.2346 5.54048 10.2613C5.5047 10.2881 5.47492 10.3213 5.4529 10.3592C5.43088 10.397 5.41707 10.4386 5.41227 10.4815C5.40747 10.5244 5.41178 10.5679 5.42496 10.6092L5.6632 11.903C5.6632 11.903 1.61697 10.5692 1.34799 10.4563C0.917118 10.2732 0.556832 9.96797 0.316798 9.58274C0.0767636 9.19751 -0.0311981 8.75124 0.00779494 8.30546C0.046788 7.85967 0.230816 7.43632 0.53451 7.09375C0.838204 6.75119 1.24661 6.50629 1.70343 6.39281C2.38356 6.22357 4.91005 5.66491 5.6459 5.49931C5.8476 5.45164 6.05476 5.4278 6.26264 5.42834ZM6.28377 12.5254H6.3856C6.70367 12.5408 7.01528 12.6163 7.30215 12.7473C7.58903 12.8783 7.84539 13.0623 8.0562 13.2884C8.26701 13.5145 8.42803 13.7782 8.5298 14.064C8.63157 14.3499 8.67206 14.6521 8.64887 14.9529C8.62966 15.1968 8.58739 15.4843 8.54896 16.1977C8.54638 16.2407 8.55294 16.2838 8.56827 16.3244C8.58359 16.365 8.60737 16.4023 8.63819 16.434C8.66901 16.4658 8.70624 16.4913 8.74768 16.5092C8.78912 16.527 8.83392 16.5368 8.87943 16.538L10.2512 16.7199C10.2512 16.7199 7.6671 19.9573 7.4692 20.1629C7.25685 20.3869 6.99705 20.5661 6.70674 20.6887C6.41642 20.8113 6.1021 20.8746 5.78424 20.8744C5.74005 20.8744 5.69586 20.8744 5.65167 20.8744C5.35276 20.858 5.06022 20.7858 4.79076 20.6622C4.5213 20.5386 4.2802 20.3659 4.08125 20.1539C3.8823 19.942 3.7294 19.695 3.63128 19.4271C3.53317 19.1592 3.49176 18.8756 3.50944 18.5925C3.54978 17.9246 3.77842 15.4734 3.83221 14.7546C3.87109 14.1593 4.14467 13.5996 4.59874 13.1864C5.05281 12.7731 5.65422 12.5366 6.28377 12.5236V12.5254ZM16.4954 14.0649C16.4954 14.0649 18.9373 17.3987 19.0834 17.6407C19.3208 18.028 19.4252 18.4756 19.3821 18.9216C19.3389 19.3675 19.1504 19.7898 18.8426 20.1297C18.5348 20.4696 18.1229 20.7104 17.6642 20.8188C17.2054 20.9271 16.7224 20.8976 16.2821 20.7343C15.627 20.4923 13.2427 19.5278 12.5395 19.2549C11.938 19.0282 11.4521 18.5904 11.1832 18.0326C10.9144 17.4748 10.8833 16.8403 11.0966 16.2614C11.2089 15.9798 11.3794 15.7224 11.5982 15.5042C11.817 15.286 12.0796 15.1114 12.3707 14.9907C12.6617 14.87 12.9753 14.8056 13.293 14.8013C13.6106 14.797 13.926 14.8529 14.2206 14.9657C14.4588 15.0567 14.7336 15.1841 15.4368 15.4406C15.4774 15.4577 15.5211 15.4669 15.5655 15.4679C15.636 15.4676 15.7047 15.4466 15.7622 15.4078C15.8196 15.3691 15.863 15.3144 15.8863 15.2514L16.4954 14.0649ZM20.6146 6.32548C21.1396 6.32432 21.6486 6.49681 22.0537 6.81317C22.5214 7.17686 22.8178 7.70135 22.878 8.27169C22.9381 8.84202 22.7571 9.41168 22.3745 9.85581C21.9288 10.3726 20.2265 12.2215 19.7366 12.7783C19.4978 13.0498 19.1992 13.2684 18.8616 13.4187C18.524 13.5689 18.1557 13.6473 17.7827 13.6482C17.327 13.6506 16.8803 13.5288 16.4956 13.2975C16.111 13.0662 15.8047 12.735 15.6132 12.3434C15.4216 11.9518 15.353 11.5164 15.4154 11.0889C15.4778 10.6614 15.6686 10.2599 15.9651 9.93224C16.1304 9.75026 16.3494 9.53735 16.8163 8.98232C16.8449 8.94872 16.8662 8.91002 16.8788 8.86852C16.8915 8.82701 16.8952 8.78352 16.8898 8.74062C16.8845 8.69772 16.8701 8.65627 16.8476 8.61872C16.825 8.58116 16.7948 8.54825 16.7586 8.52193L15.7634 7.61205C15.7634 7.61205 19.8576 6.43466 20.1439 6.37825C20.2987 6.34772 20.4565 6.33247 20.6146 6.33276V6.32548ZM11.4443 1.73238e-06C11.8269 -0.000457317 12.2034 0.0903203 12.5392 0.263964C12.875 0.437608 13.1592 0.688529 13.3656 0.993589C13.7499 1.55589 15.0775 3.66681 15.479 4.28007C15.8263 4.79746 15.9492 5.42187 15.8221 6.02303C15.6951 6.62418 15.3278 7.15564 14.797 7.5065C14.4124 7.74708 13.961 7.87378 13.5001 7.87045C13.0924 7.87068 12.6914 7.77236 12.335 7.5848C11.9786 7.39724 11.6787 7.12664 11.4636 6.79861C11.3291 6.58934 11.185 6.33458 10.7757 5.73406C10.7508 5.69817 10.7185 5.66736 10.6808 5.64341C10.6431 5.61945 10.6008 5.60284 10.5563 5.59454C10.5117 5.58625 10.4659 5.58642 10.4215 5.59507C10.377 5.60371 10.3348 5.62065 10.2973 5.64489L9.07348 6.26179C9.07348 6.26179 9.15993 2.20009 9.1926 1.92349C9.25218 1.39659 9.51485 0.909012 9.93032 0.55411C10.3458 0.199208 10.8849 0.00191517 11.4443 1.73238e-06Z"
                        fill="#2F384C"
                    />
                </svg>
            </div>
        </template>

        <div v-if="!embedded" class="content-container">
            <div v-if="canSendNotices || sent.length" class="mailboxes">
                <!-- tabs: `received`, `sent`, `scheduled` -->
                <template v-for="tab in tabs">
                    <!-- if has send notice permission, show all tabs, otherwise only show sent & received -->
                    <div
                        v-if="tab !== 'scheduled' || canSendNotices"
                        :key="tab"
                        :class="['mailbox', tab, { active: mailbox === tab }]"
                        @click="goMailbox(tab)"
                    >
                        {{ tab }}
                    </div>
                </template>
            </div>
            <div class="mailbox-body">
                <RequestNotificationPermissionPanel />
                <Scrollable :pull-down="refreshMailbox" bottom-padding>
                    <EngagementBanner />
                    <div class="messages">
                        <template v-if="messages.length">
                            <NoticeRow
                                v-for="message in messages"
                                :key="message.id"
                                :mailbox="mailbox"
                                :recipients="recipients"
                                :message="message"
                                @click="onClickMessage(message)"
                            />
                        </template>
                        <div v-else class="no-message">{{ emptyMessage }}</div>
                    </div>
                </Scrollable>
            </div>
            <PortalContainer v-if="showMessageModal" @back="onClose">
                <Modal
                    vanilla
                    :show="showMessageModal"
                    :size="modalSize.Full"
                    :has-close="false"
                    :allow-click-out="true"
                    :close="onClose"
                >
                    <NoticeMessage
                        v-if="!!message"
                        :id="message.id"
                        :message="message"
                        :message-type="messageType"
                        :mailbox="mailbox"
                        @close="onClose"
                    />
                </Modal>
            </PortalContainer>
            <!-- request push notification permission modal -->
            <RequestNotificationPermissionModal />
        </div>

        <ScreenBottomButton
            v-if="canSendNotices"
            :icon="iconPencil"
            title="Send Notice"
            @click="goCompose"
        />
    </WebViewScreen>
</template>

<script lang="ts">
import { Component, Prop, Watch, Vue } from 'vue-facing-decorator'
import { useRoute, useRouter } from 'vue-router'
import Loading from '@/components/Loading.vue'
import { Action, Getter } from 'vuex-facing-decorator'
import { IMessage, IRecipient } from '@/entities/notices'
import NoticeRow from '@/components/Notices/NoticeRow.vue'
import Modal from '@/components/Modal.vue'
import { ModalSize } from '@/components/modal-size'
import NoticeMessage from '@/components/Notices/NoticeMessage.vue'
import { embedded, postMessageToRNWebView } from '@/utils/react-native-webview'
import WebViewScreen from '@/components/WebView/WebViewScreen.vue'
import Scrollable from '@/components/Scrollable.vue'
import PortalContainer from '@/mobile/src/components/containers/PortalContainer.vue'
import ScreenBottomButton from '@/components/Notices/ScreenBottomButton.vue'
import IconPencil from '@/assets/img/Icons/White/Pencil.svg'
import EngagementBanner from '@/mobile/src/components/engagement/EngagementBanner.vue'
import RequestNotificationPermissionPanel from '@/mobile/src/components/RequestNotificationPermissionPanel.vue'
import RequestNotificationPermissionModal from '@/mobile/src/components/RequestNotificationPermissionModal.vue'

@Component({
    components: {
        EngagementBanner,
        ScreenBottomButton,
        RequestNotificationPermissionModal,
        RequestNotificationPermissionPanel,
        Scrollable,
        NoticeMessage,
        Modal,
        NoticeRow,
        Loading,
        WebViewScreen,
        PortalContainer,
    },
})
export default class Mailbox extends Vue {
    @Prop({ type: String }) private mailbox!: string // [received | sent | scheduled]
    @Prop({ type: String }) private messageType!: string // [message]
    @Prop({ type: String }) private messageId!: string // automatically open this message if received from a push notification

    @Getter private sent!: IMessage[] // sent notices list
    @Getter private received!: IMessage[] // recieved list
    @Getter private scheduled!: IMessage[] // scheduled list
    @Getter private recipients!: IRecipient[]
    @Getter private canSendNotices!: number

    @Action private loadMessagesSent
    @Action private loadMessagesReceived
    @Action private loadMessagesScheduled
    @Action private loadRecipients
    @Action private resetComposer
    @Action private resetComposerRecipients

    private route = useRoute()
    private router = useRouter()

    private iconPencil = IconPencil
    private modalSize = ModalSize
    private tabs = ['received', 'sent', 'scheduled']

    private async mounted() {
        await this.loadSentAndScheduledMessage()
        this.resetComposer()
        this.resetComposerRecipients()

        if (!this.received.length || (this.messageId && !this.message)) {
            await this.loadMessagesReceived()
        }
        if (!this.recipients.length) {
            this.loadRecipients()
        }
    }

    private async refreshMailbox() {
        if (window.scrollY <= 0) {
            if (this.mailbox === 'received') {
                await this.loadMessagesReceived()
            } else if (this.mailbox === 'sent') {
                if (this.canSendNotices) {
                    await this.loadMessagesSent()
                }
            } else if (this.mailbox === 'scheduled') {
                if (this.canSendNotices) {
                    await this.loadMessagesScheduled()
                }
            }
        }
    }

    @Watch('canSendNotices')
    private loadSentAndScheduledMessage() {
        if (this.canSendNotices) {
            if (!this.sent.length) {
                this.loadMessagesSent()
            }
            if (!this.scheduled.length) {
                this.loadMessagesScheduled()
            }
        }
    }

    private get messages() {
        return this[this.mailbox] || []
    }

    private get emptyMessage() {
        return this.mailbox === 'sent' || this.mailbox === 'scheduled'
            ? `You haven't ${this.mailbox} any notices yet!`
            : `Watch this space for new notices!`
    }

    private get embedded() {
        return embedded
    }

    private get showMessageModal() {
        return !!this.message
    }

    private goMailbox(mailbox) {
        if (this.mailbox !== mailbox) {
            // use replace like suggestions page
            this.router.replace({ name: 'notices', params: { mailbox } })
        }
    }

    private goCompose() {
        this.router.push({
            name: 'notices-pick-type',
            params: { mailbox: this.mailbox },
        })
    }

    private onOpenDrawer() {
        if (embedded) {
            postMessageToRNWebView({
                action: 'openDrawer', // tell react native to open drawer
            })
        }
    }

    private get message() {
        return this.messages.find(
            (message) => message.id === parseInt(this.messageId)
        )
    }

    private async onClickMessage(message: IMessage) {
        await this.router.replace({
            name: 'notices',
            params: {
                mailbox: this.mailbox,
                messageType: 'message',
                messageId: message.id.toString(),
            },
        })
    }

    private async onClose() {
        if (this.mailbox === 'received') {
            await this.loadMessagesReceived()
        }

        // prevent navigation to the same route
        // can throw NavigationDuplicated error otherwise
        if (this.route.path !== '/notices/received') {
            // change route after hiding modal so new notice could work
            await this.router.replace({
                name: 'notices',
                params: { mailbox: this.mailbox },
            })
        }
    }
}
</script>

<style lang="less" scoped>
@import '~@/styles/layout.less';
@import '~@/styles/palette.less';
@import '~@/pages/scorecard/slide.less';

.content-container {
    height: 100%;
    display: flex;
    flex-direction: column;

    .mailbox-body {
        flex: 1;
        overflow: hidden;
    }
}

.mailbox-container {
    background: @greyLight;

    .title {
        font-weight: bold;
        font-size: 16px;
        display: inline-block;
        margin: 22px 0 12px 0;
        flex: 5;
        color: #181818;
    }

    .btn-compose {
        float: right;
        position: relative;
    }

    .drawer-icon,
    .btn-compose {
        flex: 1 0 0;
    }

    .mailboxes {
        border-bottom: 1px solid @blueLight;
        text-transform: uppercase;
        display: flex;
        height: 50px;
        align-items: center;
        background: white;
        z-index: 1; // so when the content scrolls, the border bottom could still show
        flex-shrink: 0; // so that it can have its height and won't get pushed up by content

        .active {
            border-bottom: 2px solid #708fff;
            color: @blue !important;
            position: relative;
            top: 1px;
        }

        .mailbox {
            flex: 1;
            text-align: center;
            font-weight: 600;
            font-size: 14px;
            letter-spacing: 0.5px;
            color: @grey40;
            line-height: 50px;
        }
    }

    .messages {
        padding: 12px;

        .loader {
            text-align: center;
        }

        .no-message {
            text-align: center;
            color: @grey40;
            position: fixed;
            width: 100%;
            top: 50%;
        }
    }
}
</style>
